import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Container } from "@mui/system";
import { styled, useTheme } from "@mui/material/styles";
import { useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Categories from "../Component/Categories";
import Activities from "../Component/Activities";
import Blog from "../Component/Blog";
import Section from "../Component/Section";
import WhenYouNeedHelp from "../Component/WhenYouNeedHelp";
import { Outlet } from "react-router-dom";
// import TemporaryDrawer from "../Component/Header";

const drawerWidth = 240;
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,

    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const LandingPageLayout = () => {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  return (
    <>
      <Header open={open} setOpen={setOpen} />
      <Box sx={{ my: 10 }}>
        <Outlet />
        {/* <Activities />

        <Blog /> */}
      </Box>
      <Footer />
    </>
  );
};

export default LandingPageLayout;
